interface SuggestInputProps {
  value: string
  onChange: (value: string) => void
  suggestions: string[]
  placeholder?: string
  listId: string
}

/**
 * Plain controlled text input with native browser autocomplete, sourced
 * from real values already in the database (see
 * CandidateFilterOptionsController) rather than a fixed static list.
 */
export function SuggestInput({ value, onChange, suggestions, placeholder, listId }: SuggestInputProps) {
  return (
    <>
      <input
        type="text"
        list={listId}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
      />
      <datalist id={listId}>
        {suggestions.map((s) => (
          <option key={s} value={s} />
        ))}
      </datalist>
    </>
  )
}
